import ProfilLayout from "../ProfilLayout/ProfilLayout";
import { CustomModalContext, LayoutBarContext } from "../../../contexts";
import { PersonalDataContext } from "../../../contexts/UserDefaultSpace/profil/PersonalDataContext";
import { useCallback, useContext, useEffect, useMemo } from "react";
import EditNameForm from "../Default/Forms/EditNameForm";
import EditPhoneNumberForm from "../Client/EstablishemntInfos/Forms/EditPhoneNumberForm";
import ProfilCardsList from "../ProfilCardsList/ProfilCardsList";
import ProfilHome from "../ProfilHome";
import { sessionStorageKey } from "../../../consts";
import { useLocalStorage } from "../../../hooks";
import { Session } from "@/src/types";
import { getCurrentUser, patchUser } from "../../../services";

export default function PersonalData() {
    const { updatePersonalData, ...personalData } =
        useContext(PersonalDataContext);

    const { updateContent } = useContext(LayoutBarContext);

    const { updateModal, updateIsCustomModalActive } =
        useContext(CustomModalContext);

    const { storedValue: session, setValue } =
        useLocalStorage<Session>(sessionStorageKey);

    const {
        auth: { user: currentUser },
    } = session;

    const _updatePersonalData = (value: any) => {
        updatePersonalData({
            ...personalData,
            ...value,
        });
    };

    const _updateUserInfos = (key: string, value: any) => {
        updatePersonalData({
            ...personalData,
            [key]: value,
        });
    };

    const handlePutPersonalData = useCallback(async (formData: any) => {
        if (formData) {
            const putPayload = {
                ...formData,
            };
            return await patchUser(currentUser.id, putPayload);
        }
    }, []);

    const personalDataProfilCards = useMemo(() => {
        return [
            {
                key: "fisrtName",
                value: personalData?.firstName + " " + personalData?.lastName,
                label: "Nom entier",
                onClick: async () => {
                    updateModal({
                        content: (
                            <EditNameForm
                                onSubmit={async (formData: any) => {
                                    const updatingPersoDataRes =
                                        await handlePutPersonalData({
                                            first_name: formData.firstName,
                                            last_name: formData.lastName,
                                        }); //need api in back
                                    if (!updatingPersoDataRes.detail) {
                                        _updateUserInfos(
                                            "firstName",
                                            formData.firstName
                                        );
                                        _updateUserInfos(
                                            "lastName",
                                            formData.lastName
                                        );
                                        await setValue({
                                            ...session,
                                            auth: {
                                                ...session.auth,
                                                user: {
                                                    ...session.auth.user,
                                                    firstName:
                                                        formData.firstName,
                                                    lastName: formData.lastName,
                                                },
                                            },
                                        });
                                        updateIsCustomModalActive(false);
                                    }
                                }}
                                defaultValue={{
                                    firstName: personalData?.firstName,
                                    lastName: personalData?.lastName,
                                }}
                            />
                        ),
                        title: "Modifier votre nom et prénom.",
                    });
                    updateIsCustomModalActive(true);
                },
            },
            //######## user
            {
                key: "phoneNumber",
                value: personalData?.phoneNumber,
                label: "Numéro de téléphone",
                onClick: async () => {
                    updateModal({
                        content: (
                            <EditPhoneNumberForm
                                onSubmit={async (formData: any) => {
                                    const updatingPersoDataRes =
                                        await handlePutPersonalData(formData);
                                    if (!updatingPersoDataRes.detail) {
                                        _updateUserInfos(
                                            "phoneNumber",
                                            formData.phoneNumber
                                        );
                                        await setValue({
                                            ...session,
                                            auth: {
                                                ...session.auth,
                                                user: {
                                                    ...session.auth.user,
                                                    phoneNumber:
                                                        formData.phoneNumber,
                                                },
                                            },
                                        });
                                        updateIsCustomModalActive(false);
                                    }
                                }}
                                defaultValue={{
                                    phoneNumber: personalData.phoneNumber,
                                }}
                            />
                        ),
                        title: "Modifier votre numéro de téléphone?",
                    });
                    updateIsCustomModalActive(true);
                },
            },
            {
                key: "email",
                value: personalData.email,
                label: "Adresse mail",
            },
            //######## user
        ];
    }, [personalData]);

    const fetchPersonalData = useCallback(async () => {
        const currentUserFromDb = await getCurrentUser();
        _updatePersonalData(currentUserFromDb.data);
    }, []);

    useEffect(() => {
        fetchPersonalData();
    }, [fetchPersonalData]);

    return (
        <ProfilLayout
            headerTitle={"Informations sur l’établissement"}
            onBackClick={() => {
                updateContent(<ProfilHome />);
            }}
        >
            <ProfilCardsList profilCardItems={personalDataProfilCards} />
        </ProfilLayout>
    );
}
